// @flow

import type { State } from "@store/reducers";
import type {
  ServiceSettings,
  ServiceSettingsContainer,
} from "@modules/service/reducer/service-settings/types";

export const getServiceSettings = (state: State): ServiceSettingsContainer =>
  state.service.serviceSettings.settings;

export const getServiceSettingsSchema = (state: State): ?Object =>
  (state.service.serviceSettings || {}).schema;
